import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const Home = () => {
    const { websiteLoginData } = useSelector((state) => state.user);
    const [height, setHeight] = useState(window.innerHeight - 64);

    useEffect(() => {
        const updateHeight = () => {
            setHeight(window.innerHeight - 64);
        };

        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);

    return (
        <>
            <div className="w-full" style={{ height: `${height}px` }}>
                <iframe
                    src={websiteLoginData.ifram_link ? websiteLoginData.ifram_link : "https://55wingo.in/#/login"}
                    title="Responsive Iframe"
                    className="w-full h-full"
                ></iframe>
            </div>
        </>
    )
}

export default Home
